import { render, staticRenderFns } from "./#receive-list.vue?vue&type=template&id=18c68af4&scoped=true&"
import script from "./#receive-list.vue?vue&type=script&lang=js&"
export * from "./#receive-list.vue?vue&type=script&lang=js&"
import style0 from "./#receive-list.vue?vue&type=style&index=0&id=18c68af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c68af4",
  null
  
)

export default component.exports